<template>
  <div class="page1">
    <el-button @click="dialogVisible = true">新增</el-button>
    <el-button type="danger" size="small" plain @click="deleteMore">删除</el-button>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size" @handleSelect="handleSelectionChange"
            :needSelect="true">
      <el-table-column fixed="right" label="操作" width="180px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="editDialog(scope.row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <div slot="testingResult" slot-scope="scope">
        {{ scope.data.testingResult == '合格' ? '合格' : '不合格' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="40%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="timeName">
              <el-input v-model="form.timeName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开始时间" prop="startTime">
              <el-input v-model="form.startTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="结束时间" prop="endTime">
              <el-input v-model="form.endTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序号" prop="status">
              <el-input v-model="form.status"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      tableTitle: [
        {
          label: '名称',
          prop: 'timeName',
        },
        {
          label: '开始时间',
          prop: 'startTime',
        },
        {
          label: '结果时间',
          prop: 'endTime',
        }],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {
        id: '',
        timeName: '',
        startTime: '',
        endTime: ''
      },
      searchForm: {
        current: 1,
        size: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        timeName: [vxRule(true, '', "blur", "名称不能为空")],
        startTime: [vxRule(true, '', "blur", "开始时间不能为空")],
        endTime: [vxRule(true, '', "blur", "结束时间不能为空")],
        status: [vxRule(true, '', "blur", "排序号不能为空")]
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {
        id: '',
        timeName: '',
        startTime: '',
        endTime: '',
        status: 0
      }
      this.$refs.form.resetFields()
    },
    handleSelectionChange(data) {
        if (data.length > 0) {
          data.forEach((item) => {
            this.selectRoutes.push(item.id);
          });
        }
      },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => {});
    },
    async getData() {
      let res = await Http.patrolTimeList(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.records
        this.count = res.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let {
        id,
        timeName,
        startTime,
        endTime,
        status
      } = this.form
      let res = await Http.patrolTimeSave({
        id,
        timeName,
        startTime,
        endTime,
        status
      })
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }
    },
    editDialog(data) {
      this.title = '编辑信息'
      this.form = {
        id: data.id,
        timeName: data.timeName,
        startTime: data.startTime,
        endTime: data.endTime,
        status: data.status
      }
      this.dialogVisible = true
    },
    async removeRoute(ids) {
      let res = await Http.patrolTimeRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
